import { createContext, useState, FunctionComponent, ReactElement } from 'react';

export type userTypes = 'manager' | 'trader';

export enum USER {
  MANAGER = 'manager',
  TRADER = 'trader',
}

export interface IUser {
  accountId: string[];
  userId: string;
  userType: userTypes;
  sessionId: string;
  accountName: string;
  algoEngineToken: string;
  algoEngineData: any;
}

interface IProps {
  children: ReactElement;
}

export interface IContextState {
  userData: IUser | null;
  selectedTraderAccount: string | null;
}

const initialState: IContextState = {
  userData: null,
  selectedTraderAccount: null
};

const AppContext = createContext<any>(null);

const AppContextProvider: FunctionComponent<IProps> = ({ children }: IProps) => {
  const [contextState, setContext] = useState(initialState);

  return <AppContext.Provider value={[contextState, setContext]}>{children}</AppContext.Provider>;
};

export { AppContext, AppContextProvider };
